/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from "react";
import LanguageRedirectGuard from "@Components/LanguageRedirectGuard";
import wrapperHOC from "@Utils/wrapperHOC";

interface Props {
  children: React.ReactNode;
}

/**
 * Client-only wrapper for LanguageRedirectGuard
 * Ensures the language modal only renders on the client side, not during SSR
 * This prevents hydration mismatches and ensures browser APIs are available
 *
 * NOTE: This component is NOT used for China domain (amberstudent.cn)
 *       China domain doesn't use language prefixes - it's Chinese-only by default
 */
const ClientOnlyLanguageGuard: React.FC<Props> = ({ children }) => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // Mark as client-side after mount
    setIsClient(true);
  }, []);

  // During SSR or before client hydration, render children without guard
  if (!isClient) {
    return <>{children}</>;
  }

  // After client hydration, render with language guard
  return <LanguageRedirectGuard>{children}</LanguageRedirectGuard>;
};

export default wrapperHOC(ClientOnlyLanguageGuard, {
  componentName: "ClientOnlyLanguageGuard",
  showForChina: true,
});
